import React from 'react';
import { ENCON_LOGO } from '../../src/assets';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { Button, Box, Link, makeStyles, colors, Divider, ListItemText } from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';

import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

import { removeUser } from '../app/reducer/auth.reducer';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useHelp } from '../utils/HelpContext';
import { url } from 'inspector';
const logo = require('../assets/images/Logo.jpeg')
const enconLogo = require('../assets/images/Encon_Logo.png')
interface HeaderProps {
  classes: any;
  handleDrawerOpen: Function;
  open: boolean;
  isAuth?: true | false | 'loading';
  user?: {
    username?: string;
    email?: string;
    userType?: number;
  };
}

export default function AppHeader({
  classes,
  handleDrawerOpen,
  open,
  isAuth,
  user
}: HeaderProps) {

  const useStyles = makeStyles(() => ({
    tooltip: {
      backgroundColor: "#4cbb94",
      color: "#fff",
      fontSize: "13px",
      padding: "6px 10px",
      borderRadius: "6px",
      fontWeight:700
    },
    arrow: {
      color: "#4cbb94",
    },
  }));
  const { toggleHelp } = useHelp();
  const dispatch = useDispatch();
  const history = useHistory();
  const classesAppend= useStyles();
  const logOut = () => {
    dispatch(removeUser(false));
    history.push('/login');
  };

  // ✅ single menu anchor for user menu
  const [userMenuAnchor, setUserMenuAnchor] = React.useState<null | HTMLElement>(null);

  const openUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setUserMenuAnchor(event.currentTarget);
  };

  const closeUserMenu = () => {
    setUserMenuAnchor(null);
  };


  return (
    <AppBar
      style={{backgroundColor:'#48bc97'}}
      position="fixed"
      className={clsx(classes.appBar, {
        [classes.appBarShift]: open,
      })}
    >
      <Toolbar>
        <IconButton
          color='inherit'
          // style={{color:'white'}}
          aria-label="open drawer"
          onClick={() => handleDrawerOpen()}
          edge="start"
          className={clsx(classes.menuButton, {
            [classes.hide]: open,
          })}
        >
          <MenuIcon />
        </IconButton>

        <img src={enconLogo} style={{ height: '70px', width: '70px' }} />

        <Box sx={{ flexGrow: 1 }} />

        <Tooltip  classes={{ tooltip: classesAppend.tooltip, arrow: classesAppend.arrow }} title="User Guide">
          <IconButton
            color="inherit"
            // style={{color:'white'}}
            aria-label="user guide"
            component="a"
            href={(user?.userType==1 || user?.userType==2)?"https://encon-static-files.s3.ap-south-1.amazonaws.com/Admin.pptx":user?.userType==3?"https://encon-static-files.s3.ap-south-1.amazonaws.com/Inhouse.pptx":"https://encon-static-files.s3.ap-south-1.amazonaws.com/AgentandCustomer.pptx"}
            download // downloable 
            target="_blank"
            rel="noreferrer"
          >
            <HelpOutlineIcon />
          </IconButton>
        </Tooltip>

        {/* If not authenticated */}
        {!isAuth && (
          <Button
            variant="text"
            color="inherit"
            onClick={() => history.push('/login')}
          >
            Login
          </Button>
        )}

        {/* If authenticated: show user icon + menu */}
        {isAuth && (
          <>
            <Tooltip title="Account"  classes={{ tooltip: classesAppend.tooltip, arrow: classesAppend.arrow }} >
              <IconButton
                color="inherit"
                // style={{color:'green'}}
                aria-label="account menu"
                onClick={openUserMenu}
              >
                <AccountCircleIcon />
              </IconButton>
            </Tooltip>

              <Menu
  id="user-menu"
  anchorEl={userMenuAnchor}
  open={Boolean(userMenuAnchor)}
  onClose={closeUserMenu}
  getContentAnchorEl={null}
  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
>
  {/* 👤 User identity block */}
  <Box px={2} py={1.5}>
    <Typography
      variant="subtitle2"
      style={{ fontWeight: 600 }}
      noWrap
    >
      {user?.username || 'User'}
    </Typography>

    <Typography
      variant="subtitle1"
      color="textSecondary"
      noWrap
    >
      {user?.email}
    </Typography>

    <Typography
      variant="subtitle1"
      color="textSecondary"
    >
      {user?.userType==1?'Admin':user?.userType==2?'Inhouse User':user?.userType==3?'Agent':'customer'}
    </Typography>
  </Box>

  <Divider />

  {/* Actions */}
  <MenuItem
    onClick={() => {
      closeUserMenu();
      history.push('/profile');
    }}
  >
    Profile
  </MenuItem>

  <MenuItem
    onClick={() => {
      closeUserMenu();
      logOut();
    }}
  >
    Logout
  </MenuItem>
</Menu>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
}